var map = {
	"./banner-carousel.de-CH.json": 1154,
	"./banner-carousel.de-DE.json": 1155,
	"./banner-carousel.en-CA.json": 1156,
	"./banner-carousel.en-GB.json": 1157,
	"./banner-carousel.en-IN.json": 1158,
	"./banner-carousel.en-ME.json": 1159,
	"./banner-carousel.en-US.json": 1160,
	"./banner-carousel.es-EM.json": 1161,
	"./banner-carousel.es-ES.json": 1162,
	"./banner-carousel.fr-BE.json": 1163,
	"./banner-carousel.fr-CA.json": 1164,
	"./banner-carousel.fr-CH.json": 1165,
	"./banner-carousel.nl-BE.json": 1166,
	"./banner-carousel.nl-NL.json": 1167,
	"./banner-carousel.pl-PL.json": 1168,
	"./banner-carousel.pt-BR.json": 1169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1153;